import { useEffect, useState, useCallback } from "react";
import { useDispatch } from "react-redux";
import { obtenerListaContratos } from "../../../store/contratos/thunkContratos";
import { useNavigate } from "react-router-dom";

export const ListaContratos = () => {
    const dispatch = useDispatch(); // Hook de Redux para despachar acciones
     const navigate = useNavigate(); // Hook de React Router para navegar entre rutas

    // Columnas de la tabla
    const columns = [
        { key: "index", header: "#" },
        { key: "id_consecutivo_contrato", header: "Consecutivo" },
        { key: "nombre_evento_contrato", header: "Nombre Evento" },
        { key: "nombre_empresa", header: "Nombre Empresa" },
        { key: "name_admin", header: "Administrador" },
        { key: "fecha_evento_contrato", header: "Fecha Evento" },
        { key: "fecha_creacion_contrato", header: "Fecha Creación" },
        { key: "Estado_contrato", header: "Estado Contrato" },
    ];

    // Estados
    const [loading, setLoading] = useState(false); // Estado de carga
    const [dataTable, setDataTable] = useState([]); // Datos de la tabla
    const [filteredData, setFilteredData] = useState([]); // Datos filtrados
    const [searchTerm, setSearchTerm] = useState(""); // Término de búsqueda por ID consecutivo
    const [searchEventName, setSearchEventName] = useState(""); // Término de búsqueda por nombre del evento
    const [currentPage, setCurrentPage] = useState(1); // Página actual
    const [pageSize, setPageSize] = useState(10); // Tamaño de página

    const totalPages = Math.ceil(filteredData.length / pageSize); // Total de páginas

    // Función para obtener la lista de contratos desde la API
    const fetchContratos = useCallback(
        async (estado) => {
            setLoading(true); // Activa el estado de carga
            try {
                const orSql = estado === 1 ? "where Estado_coti !='Confirmada'" : "";
                const response = await dispatch(obtenerListaContratos(orSql)); // Llama al thunk de Redux
                setDataTable(response); // Actualiza el estado de la tabla con los datos obtenidos
                setFilteredData(response); // Inicializa los datos filtrados
            } catch (error) {
                console.error("Error al obtener la lista de contratos:", error);
            } finally {
                setLoading(false); // Desactiva el estado de carga
            }
        },
        [dispatch],
    );

    // Maneja el cambio de página
    const handlePageChange = (newPage) => {
        if (newPage > 0 && newPage <= totalPages) {
            setCurrentPage(newPage);
        }
    };

    // Maneja el cambio del tamaño de página
    const handlePageSizeChange = (event) => {
        setPageSize(Number(event.target.value));
        setCurrentPage(1); // Reinicia a la primera página
    };

    // Maneja el cambio en el término de búsqueda por ID consecutivo
    const handleSearchChange = (event) => {
        const value = event.target.value;
        setSearchTerm(value); // Actualiza el término de búsqueda por ID consecutivo
        filterData(value, searchEventName);
    };

    // Maneja el cambio en el término de búsqueda por nombre de evento
    const handleSearchEventNameChange = (event) => {
        const value = event.target.value;
        setSearchEventName(value); // Actualiza el término de búsqueda por nombre del evento
        filterData(searchTerm, value);
    };

    // Filtra los datos basados en los términos de búsqueda
    const filterData = (idFilter, eventNameFilter) => {
        let filtered = dataTable;

        if (idFilter) {
            filtered = filtered.filter((contrato) => contrato.id_consecutivo_contrato.toString().includes(idFilter));
        }

        if (eventNameFilter) {
            filtered = filtered.filter((contrato) => contrato.nombre_evento_contrato.toLowerCase().includes(eventNameFilter.toLowerCase()));
        }

        setFilteredData(filtered);
        setCurrentPage(1); // Reinicia a la primera página
    };

    // Efecto para cargar las cotizaciones al montar el componente
    useEffect(() => {
        if (!dataTable.length) {
            fetchContratos(1); // Obtiene cotizaciones pendientes
        }
    }, [dataTable, fetchContratos]);

    // Calcula los datos de la página actual
    const paginatedData = filteredData.slice((currentPage - 1) * pageSize, currentPage * pageSize);

    // Formatea la fecha para mostrarla en un formato amigable
    const formatearFecha = (fecha) => {
        const date = new Date(fecha);
        return date.toLocaleDateString("es-ES", { weekday: "long", year: "numeric", month: "long", day: "numeric" });
    };

    const crarContrato = () => {
        navigate(`/contratos/crear?data=0`); // Redirige a la página de copia
    };

    return (
        <>
            <code>
                Esta vista está en desarrollo, por lo que la información de los contratos no está disponible actualmente. Estamos trabajando para
                habilitarla pronto.
            </code>
            <br />
            <br />
            <div className="row">
                {/* Filtro por ID consecutivo */}
                <div className="col-md-4 mb-2">
                    <label htmlFor="searchInput" className="form-label">
                        {" "}
                        Buscar por ID consecutivo:
                    </label>
                    <input
                        id="searchInput"
                        className="form-control"
                        type="text"
                        placeholder="Ingrese ID consecutivo"
                        value={searchTerm}
                        onChange={handleSearchChange}
                    />
                </div>

                {/* Filtro por nombre de evento */}
                <div className="col-md-4 mb-2">
                    <label htmlFor="searchEventNameInput" className="form-label">
                        {" "}
                        Buscar por Nombre de Evento:
                    </label>
                    <input
                        id="searchEventNameInput"
                        className="form-control"
                        type="text"
                        placeholder="Ingrese Nombre de Evento"
                        value={searchEventName}
                        onChange={handleSearchEventNameChange}
                    />
                </div>
            </div>
            <button className="btn btn-dark" onClick={() => crarContrato()}>
                Generar Contrato
            </button>
            <br />
            <br />
            {/* Muestra un indicador de carga mientras se obtienen los datos */}
            {loading ? (
                <div className="text-center">
                    <div className="spinner-border" role="status">
                        <span className="visually-hidden">Cargando...</span>
                    </div>
                </div>
            ) : (
                <>
                    {/* Selector para tamaño de página */}
                    <div className="d-flex justify-content-between mb-3">
                        <select
                            id="clientsPerPage"
                            className="form-select"
                            value={pageSize}
                            onChange={handlePageSizeChange}
                            style={{ width: "100px" }}
                        >
                            <option value={10}>10</option>
                            <option value={20}>20</option>
                            <option value={30}>30</option>
                            <option value={50}>50</option>
                            <option value={70}>70</option>
                            <option value={100}>100</option>
                        </select>
                    </div>

                    {/* Tabla de datos */}
                    <div className="table-responsive">
                        <table className="table table-striped table-hover" style={{ fontSize: "15px", width: "100%" }}>
                            <thead>
                                <tr>
                                    {columns.map((column) => (
                                        <th key={column.key}>{column.header}</th>
                                    ))}
                                </tr>
                            </thead>
                            <tbody>
                                {paginatedData.map((contrato, index) => (
                                    <tr key={index} onClick={() => navigate(`/contratos/ver?data=${contrato.id_contrato}`)}>
                                        <td>{index + 1}</td>
                                        <td>{contrato.id_consecutivo_contrato}</td>
                                        <td>{contrato.nombre_evento_contrato}</td>
                                        <td>{contrato.nombre_empresa}</td>
                                        <td>{contrato.name_admin}</td>
                                        <td>{contrato.fecha_evento_contrato}</td>
                                        <td>{formatearFecha(contrato.fecha_creacion_contrato)}</td>
                                        <td>{contrato.Estado_contrato}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>

                    {/* Controles de paginación */}
                    <div className="pagination-controls text-center mt-3">
                        <button className="btn btn-dark" onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1}>
                            Anterior
                        </button>
                        <span className="mx-3">
                            Página {currentPage} de {totalPages}
                        </span>
                        <button className="btn btn-dark" onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages}>
                            Siguiente
                        </button>
                    </div>
                </>
            )}
        </>
    );
};
